import set from 'hs-lodash/set';
export default set;